import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Gallery from '../components/ui/Gallery';
import { AwardIcon, UsersIcon, HeartIcon } from 'lucide-react';
const ProjectCommissioning = () => {
  const commissioningImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nn93xnwTcDMxPXw6huLouK/WhatsApp_Image_2025-08-14_at_15.45.40_%281%29.jpg',
    alt: 'Project commissioning ceremony',
    caption: 'Alumni and dignitaries at ribbon-cutting ceremony'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iGKm8FAGziRTZix4D1xoeG/WhatsApp_Image_2025-08-14_at_15.45.40.jpg',
    alt: 'Classroom inspection',
    caption: 'Alumni members inspecting newly renovated classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u8fYmTHhZVGb7kvS8fafFc/WhatsApp_Image_2025-08-14_at_15.45.39_%282%29.jpg',
    alt: 'Modern classroom',
    caption: 'State-of-the-art classroom with modern furniture'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dQoGZew8zGmBimUAkZ9tYb/WhatsApp_Image_2025-08-14_at_15.45.39_%281%29.jpg',
    alt: 'Project viewing',
    caption: 'Alumni association viewing completed project'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/p35cX7359Z9n8B2uNgbpJC/WhatsApp_Image_2025-08-14_at_15.45.39.jpg',
    alt: 'Laboratory facilities',
    caption: 'Upgraded laboratory facilities inspection'
  }];
  return <div className="min-h-screen bg-white" data-id="element-5854">
      <PageHeader title="Alumni Project Commissioning" description="Celebrating the generous contributions of our alumni through dedicated projects that enhance learning at IGS." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/nn93xnwTcDMxPXw6huLouK/WhatsApp_Image_2025-08-14_at_15.45.40_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Alumni',
      path: '/alumni'
    }, {
      label: 'Project Commissioning',
      path: '/project-commissioning'
    }]} data-id="element-5855" />
      <div className="container mx-auto px-4 py-12" data-id="element-5856">
        <div className="text-center mb-12" data-id="element-5857">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5858">
            Alumni Giving Back to Their Alma Mater
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6" data-id="element-5859"></div>
          <p className="text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-5860">
            Our distinguished alumni continue to demonstrate their commitment to
            Isonyin Grammar School through generous donations and infrastructure
            projects. These initiatives have significantly improved our learning
            environment and facilities, ensuring that current and future
            students benefit from world-class educational resources.
          </p>
        </div>
        {/* Impact Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-5861">
          <div className="bg-blue-50 rounded-lg p-6 text-center border border-blue-100" data-id="element-5862">
            <div className="inline-block p-4 bg-blue-700 rounded-full mb-4" data-id="element-5863">
              <AwardIcon className="h-8 w-8 text-white" data-id="element-5864" />
            </div>
            <h3 className="text-3xl font-bold text-blue-900 mb-2" data-id="element-5865">25+</h3>
            <p className="text-gray-700" data-id="element-5866">Completed Projects</p>
          </div>
          <div className="bg-yellow-50 rounded-lg p-6 text-center border border-yellow-100" data-id="element-5867">
            <div className="inline-block p-4 bg-yellow-500 rounded-full mb-4" data-id="element-5868">
              <UsersIcon className="h-8 w-8 text-blue-900" data-id="element-5869" />
            </div>
            <h3 className="text-3xl font-bold text-blue-900 mb-2" data-id="element-5870">50+</h3>
            <p className="text-gray-700" data-id="element-5871">Contributing Alumni Sets</p>
          </div>
          <div className="bg-green-50 rounded-lg p-6 text-center border border-green-100" data-id="element-5872">
            <div className="inline-block p-4 bg-green-600 rounded-full mb-4" data-id="element-5873">
              <HeartIcon className="h-8 w-8 text-white" data-id="element-5874" />
            </div>
            <h3 className="text-3xl font-bold text-blue-900 mb-2" data-id="element-5875">Countless</h3>
            <p className="text-gray-700" data-id="element-5876">Students Impacted</p>
          </div>
        </div>
        {/* Recent Projects Gallery */}
        <div className="mb-16" data-id="element-5877">
          <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-5878">
            Recent Project Commissioning Events
          </h3>
          <Gallery images={commissioningImages} columns={3} gap="large" data-id="element-5879" />
        </div>
        {/* Notable Projects */}
        <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-5880">
          <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-5881">
            Notable Alumni-Funded Projects
          </h3>
          <div className="space-y-6" data-id="element-5882">
            <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-5883">
              <h4 className="font-bold text-blue-900 mb-2" data-id="element-5884">
                Modern ICT Laboratory
              </h4>
              <p className="text-gray-700 mb-2" data-id="element-5885">
                Donated by: Class of 1985 Alumni Association
              </p>
              <p className="text-gray-600 text-sm" data-id="element-5886">
                A state-of-the-art computer laboratory equipped with 40 modern
                computers, projectors, and high-speed internet connectivity to
                support 21st-century learning.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-5887">
              <h4 className="font-bold text-blue-900 mb-2" data-id="element-5888">
                Renovated Science Laboratories
              </h4>
              <p className="text-gray-700 mb-2" data-id="element-5889">
                Donated by: Class of 1990 Alumni Association
              </p>
              <p className="text-gray-600 text-sm" data-id="element-5890">
                Complete renovation of Chemistry, Physics, and Biology
                laboratories with modern equipment and safety features.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-5891">
              <h4 className="font-bold text-blue-900 mb-2" data-id="element-5892">
                Multipurpose Hall Upgrade
              </h4>
              <p className="text-gray-700 mb-2" data-id="element-5893">
                Donated by: Class of 1978 Alumni Association
              </p>
              <p className="text-gray-600 text-sm" data-id="element-5894">
                Renovation and modernization of the school hall with new
                seating, sound system, and lighting for assemblies and events.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-5895">
              <h4 className="font-bold text-blue-900 mb-2" data-id="element-5896">
                Library Expansion Project
              </h4>
              <p className="text-gray-700 mb-2" data-id="element-5897">
                Donated by: Class of 1995 Alumni Association
              </p>
              <p className="text-gray-600 text-sm" data-id="element-5898">
                Expansion of the school library with additional reading space,
                modern furniture, and a digital resource center.
              </p>
            </div>
          </div>
        </div>
        {/* Call to Action */}
        <div className="bg-blue-900 text-white rounded-lg p-8 text-center" data-id="element-5899">
          <h3 className="text-2xl font-bold mb-4" data-id="element-5900">
            Want to Give Back to Your Alma Mater?
          </h3>
          <p className="mb-6 max-w-2xl mx-auto" data-id="element-5901">
            Join our alumni in making a lasting impact on future generations of
            IGS students. Whether through infrastructure projects, scholarships,
            or other contributions, your support makes a difference.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-5902">
            <a href="/support" className="px-6 py-3 bg-yellow-500 text-blue-900 font-bold rounded-md hover:bg-yellow-400 transition-colors shadow-lg" data-id="element-5903">
              Support IGS
            </a>
            <a href="/contact" className="px-6 py-3 bg-white text-blue-900 font-bold rounded-md hover:bg-gray-100 transition-colors shadow-lg" data-id="element-5904">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default ProjectCommissioning;